export function validateCNS(cns: string): boolean {
  const cleanCNS = cns.replace(/\D/g, '')

  if (!/^\d{15}$/.test(cleanCNS)) return false

  const inicio = cleanCNS.charAt(0)

  if (inicio === '1' || inicio === '2') {
    let add = 0
    for (let i = 0; i < 15; i++) {
      add += parseInt(cleanCNS.charAt(i)) * (15 - i)
    }
    return add % 11 === 0
  }

  if (['7', '8', '9'].includes(inicio)) {
    let add = 0
    for (let i = 0; i < 15; i++) {
      add += parseInt(cleanCNS.charAt(i)) * (15 - i)
    }
    return add % 11 === 0
  }

  return false
}